import LogoIcon from "~/components/icons/LogoIcon";
import { cn } from "~/lib/utils";

interface GlobalLoaderProps {
  /** Messaggio opzionale mostrato sotto lo spinner (es. "Accesso in corso"). */
  message?: string;
  /** Classi extra (es. `z-[100]` per stare sopra a una modale). */
  className?: string;
}

export function GlobalLoader({ message, className }: GlobalLoaderProps) {
  return (
    <div
      className={cn(
        "fixed inset-0 space-y-4 z-50 flex flex-col items-center justify-center bg-white bg-opacity-75 backdrop-blur-sm animate-in fade-in-60",
        className,
      )}
    >
      <LogoIcon className="fill-secondary -ml-4" />
      <div className="h-6 w-6 animate-spin rounded-full border-2 border-solid border-secondary border-t-transparent"></div>
      {message ? (
        <span className="text-lg animate-pulse text-center px-6">
          {message}
        </span>
      ) : null}
    </div>
  );
}
